import { render, staticRenderFns } from "./DocumentationSettings.vue?vue&type=template&id=f8dc2dbc&"
import script from "./DocumentationSettings.vue?vue&type=script&lang=js&"
export * from "./DocumentationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports